module.exports = __webpack_public_path__ + "static/media/post-alert.a2066135.mp3";